import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/components/Welcome'
import Rhinoplasty from '@/components/pages/Rhinoplasty'
import Facelift from '@/components/pages/Facelift'
import Liposuction from '@/components/pages/Liposuction'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'Welcome',
      path: '/',
      component: Welcome
    },
    {
      name: 'Rhinoplasty',
      path: '/procedures/nose-procedures/rhinoplasty',
      component: Rhinoplasty
    },
    {
      name: 'Facelift',
      path: '/procedures/face-neck-procedures/simoni-facelift',
      component: Facelift
    },
    {
      name: 'Liposuction',
      path: '/procedures/body-procedures/liposuction',
      component: Liposuction
    },
    /* {
      path: '/menu/edit/items/:item',
      name: 'EditItem',
      component: EditItem,
      props: true
    }, */
    {
      path: '*',
      redirect: '/'
    }
  ]
})
